const DocumentTypes = {
  IntitialEvaluation: 1,
  AdditionalEvaluation: 2,
  MinuteReferralEvaluationAt: 13,
  MinutaDiscussionSigned: 16,
  EvaluationReportSigned: 17,
  Minuta: 20,
  Otro: 21,
  Otro_2: 198,
  CopiaDeQuerella: 22,
  ReferralServiceAT: 23,
  PreviousEvaluationAT: 24,
  LocationRejectedDocument: 26,
  MinuteControversy: 28,
  MinutaResolucionControversia: 29,
  SAEE_14EvaluacionFuncionalConducta: 152,
  MinutaServiciosCompensatorios: 174,

  CertTarea15ManualEEMadrePadre: 210,
  PropuestaServicios: 209,

  //Intervetions Plans
  PlanDeIntervencion: 83,
  PaquetePlanAnual: 84,
  PlanDeEnmienda: 85,
  ResumenResultadoDeServicios: 86, //No existe :(
  PlanDeIntervencionFirmado: 225,
  InformeAltaBajaSAEESR06: 100,
  InformedeLogrosDiciembre: 244,
  InformedeLogrosMayo: 245,
  EvaluationDiscussionMinute: 66,
  SAEE_EFA3: 1192,
  SAEE_EFA4: 1546,
  SAEE_Minute: 1193,
  OtherDocuments: 1194,
  DocumentServiceCost: 1555,
  SAEE_20: 1578,
  SAEE_14: 1609,
  SAEE_FBA_01: 1610,
  SAEE_FBA_02: 1611,
  Certification_ORE_Discipline: 1627,
  Certification_ORE_Egress: 1628,
  MinutaDeAcuerdo: 1642,
  TapAlternativeLocationDocument: 1644,
  DeterminateTapAlternativeLocationDocument: 1645,
  OtherMedicaidCertificationDocument: 1647,
  ResolucionJuez: 1651,
  DocumentoConsulta: 1652,
};

export const Categories = {
  TapAlternativeLocationDocument: 'TapAlternativeLocationDocument',
  DeterminateTapAlternativeLocationDocument:
    'DeterminateTapAlternativeLocationDocument',
  OtherMedicaidCertificationDocument: 'OtherMedicaidCertificationDocument',
};

export default DocumentTypes;
